import React, { useEffect, useReducer, useState } from "react";
import {
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import { webhookService } from "../../utils/services/webhookService";
import { toast } from "react-toastify";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import WebhookModal from "../webhook-modal";
import { ActionTableCellComponent } from "../action-table-component";
import AddIcon from "@mui/icons-material/Add";
import { omsService } from "../../utils/services/omsProvider";
import { styled, Switch } from "@mui/material";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { GreenRedSwitch } from "../switch/green-red-switch";
const init = [{ topic: "", address: "", metafield_namespaces: [] }];

const reducer = (state, action) => {
  switch (action.type) {
    case "INIT_DATA":
      return init;
    case "ADD_WEBHOOK":
      return [...state, { topic: "", address: "", metafield_namespaces: [] }];
    case "REMOVE_WEBHOOK":
      return state.filter((_, i) => i !== action.index);
    case "WEBHOOK_CHANGE":
      return state.map((x, i) =>
        i === action.index ? { ...x, ...action.value } : x,
      );
    case "EDIT_WEBHOOK":
      return [
        {
          address: action.value.address,
          topic: action.value.topic,
          metafield_namespaces: action.value.metafield_namespaces,
        },
      ];
    case "RESET_TO_INIT":
      return init;
    default:
      return state;
  }
};
const OMSList = ({
  isOpened,
  disabled,
  onClickAddOms,
  onViewOmsData,
  onEditOms,
  handleDeleteClick,
  clientId,
  onClickLocation,
  setSelectedProvider,
  openWebhook,
  setOpenWebhook,
  webhooks,
  setWebhooks,
  selectedWebhookData,
  setSelectedWebhookData,
}) => {
  const [newWebhook, setNewWebhook] = useReducer(reducer, init);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openOmsChangeConfirmation, setOpenOmsChangeConfirmation] =
    useState(false);
  const [selectedOmsData, setSelectedOmsData] = useState({});
  const [selectedWebhook, setSelectedWebhook] = useState({});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWebhookData = async (id) => {
    setLoading(true);
    try {
      const response = await webhookService.fetch(id);
      if (response.webhooks) {
        setWebhooks(response.webhooks);
      } else {
        setWebhooks(response);
      }
    } catch (error) {
      console.error("Fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const submit = async (provider) => {
    if (selectedWebhook?.id || selectedWebhook?._id) {
      try {
        setLoading(true);
        await webhookService.edit(
          {
            ...selectedWebhook,
            address: newWebhook[0].address,
            topic: newWebhook[0].topic,
            metafield_namespaces: newWebhook[0].metafield_namespaces,
          },
          provider,
          clientId,
        );
        fetchWebhookData(selectedWebhookData._id);
        toast.success("Updated successfully!");
        setSelectedWebhook({});
        setNewWebhook({ type: "INIT_DATA" });
      } catch (error) {
        console.error("Update failed:", error);
      } finally {
        setLoading(false);
      }
    } else {
      if (newWebhook.filter((x) => x.address && x.topic)?.length) {
        try {
          setLoading(true);
          await webhookService.create(
            newWebhook.filter((x) => x.address && x.topic),
            clientId,
            provider,
          );
          fetchWebhookData(selectedWebhookData._id);
          toast.success("Created successfully!");
          setNewWebhook({ type: "INIT_DATA" });
        } catch (error) {
          console.error("Create failed:", error);
        } finally {
          setLoading(false);
        }
      } else {
        toast.error("Please fill in all fields.");
      }
    }
  };

  const handleRegisterWebhooks = async (omsConfigId) => {
    setLoading(true);
    try {
      await webhookService.registerAll(clientId, omsConfigId);
      toast.success("Webhooks registered successfully!");
      if (openWebhook !== null) fetchWebhookData(selectedWebhookData._id);
    } catch (error) {
      console.error("Register webhooks failed:", error);
      toast.error("Failed to register webhooks.");
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = async (data, shop_name) => {
    try {
      setLoading(true);
      await webhookService.delete(data, shop_name, clientId);
      fetchWebhookData(selectedWebhookData._id);
      toast.success("Deleted successfully!");
      setOpenConfirmation(false);
      setLoading(false);
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (webhook) => {
    setSelectedWebhook(webhook);
    setNewWebhook({
      type: "EDIT_WEBHOOK",
      value: { ...webhook, address: webhook.address.split("?")[0] },
    });
  };

  const handleRowClick = (index, item) => {
    console.log(index);

    setOpenWebhook(openWebhook == index ? null : index);
    if (openWebhook !== index) fetchWebhookData(item?._id);
    setSelectedWebhookData(item);
  };

  const handleCancel = () => {
    setNewWebhook({ type: "RESET_TO_INIT" });
    setSelectedWebhook({});
  };
  const fetchProviderDetails = async (id, signal) => {
    if (id) {
      setLoading(true);
      try {
        const omsResponse = await omsService.fetch(id, "", "", { signal });

        setData(omsResponse.data);
      } catch (error) {
        console.error("Fetch failed:", error);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (isOpened) {
      fetchProviderDetails(clientId, signal);
    }
    return () => {
      controller.abort();
    };
  }, [isOpened]);
  const onChangePublishToOms = async (id, currentValue) => {
    setLoading(true);
    try {
      await omsService.edit(
        { publish_to_oms: !selectedOmsData?.publish_to_oms },
        selectedOmsData._id,
      );
      toast.success("Publish to OMS updated successfully!");
      fetchProviderDetails(clientId);
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Failed to update Publish to OMS.");
    } finally {
      setLoading(false);
      setOpenOmsChangeConfirmation(false);
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <TableContainer
          component={Paper}
          sx={{
            overflow: "auto",
            mt: 1,
            maxHeight: 500,
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)", // Soft shadow
            border: "1px solid var(--border-color)", // Light grey border
            borderRadius: "8px", // Rounded corners for a cleaner look
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "var(--table-header-bg)",
                    fontWeight: "bold",
                  }}
                >
                  OMS
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "var(--table-header-bg)",
                    fontWeight: "bold",
                  }}
                >
                  Shop Name
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "var(--table-header-bg)",
                    fontWeight: "bold",
                  }}
                >
                  Webhook
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "var(--table-header-bg)",
                    fontWeight: "bold",
                  }}
                >
                  Publish Catalog
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: "var(--table-header-bg)",
                    fontWeight: "bold",
                  }}
                >
                  <Button
                    disabled={disabled}
                    onClick={onClickAddOms}
                    style={{
                      // backgroundColor: disabled ? "#F0F0F0" : "var(--primary-blue)",
                      padding: 0,
                      marginRight: 8,
                      // paddingRight: 10,
                      minHeight: 30,
                      // marginTop: 1,
                      // marginBottom: 1,
                      border: disabled
                        ? "1px solid var(--text-secondary)"
                        : `1px solid var(--primary-blue)`,
                    }}
                    aria-label="oms"
                    variant="outlined"
                    startIcon={
                      <AddIcon
                        sx={{
                          color: disabled
                            ? "var(--text-secondary)"
                            : "var(--primary-blue)",
                        }}
                      />
                    }
                  >
                    <Typography
                      fontSize="12px"
                      color={
                        disabled
                          ? "var(--text-secondary)"
                          : "var(--primary-blue)"
                      }
                      fontWeight={500}
                      fontFamily={"poppins"}
                    >
                      OMS
                    </Typography>
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                .map((item) => ({
                  ...item,
                  action: (
                    <ActionTableCellComponent
                      selectedData={item}
                      handleViewClick={(data) =>
                        onViewOmsData && onViewOmsData(data)
                      }
                      handleEditClick={(data) => onEditOms && onEditOms(data)}
                      handleDeleteClick={handleDeleteClick}
                    ></ActionTableCellComponent>
                  ),
                }))
                ?.map((data, index) => (
                  <React.Fragment key={index}>
                    <TableRow
                      sx={{
                        backgroundColor:
                          index % 2 === 0
                            ? "var(--row-bg-odd)"
                            : "var(--row-bg-even)",
                      }}
                    >
                      <TableCell>
                        <CustomTypography fontSize={13}>
                          {data?.provider?.name}
                        </CustomTypography>
                      </TableCell>
                      <TableCell>
                        <CustomTypography fontSize={13}>
                          {data?.shop_name}
                        </CustomTypography>
                      </TableCell>
                      <TableCell>
                        <Box display="flex" alignItems="center">
                          <Button
                            sx={{
                              textTransform: "none",
                              color: "var(--primary-blue)",
                              border: "0.5px solid var(--primary-blue)",
                              padding: "6px",
                              borderRadius: "5px",
                              display: "flex",
                              alignItems: "center",
                            }}
                            onClick={() => {
                              handleRowClick(index, data);
                            }}
                          >
                            <img alt="link" src="/link.png" />
                            <CustomTypography
                              fontSize={13}
                              sx={{ marginLeft: 1 }}
                            >
                              Webhook
                            </CustomTypography>
                          </Button>

                          <IconButton
                            onClick={() => {
                              setSelectedProvider(data);
                              onClickLocation && onClickLocation();
                            }}
                            sx={{
                              marginLeft: 1,
                              border: "0.5px solid var(--primary-blue)",
                              borderRadius: 5,
                            }}
                          >
                            <AddLocationAltIcon
                              sx={{ color: "var(--primary-blue)" }}
                            />
                          </IconButton>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <GreenRedSwitch
                          size="small"
                          checked={data?.publish_to_oms || false}
                          onChange={() => {
                            setOpenOmsChangeConfirmation(true);
                            setSelectedOmsData(data);
                          }}
                        />
                      </TableCell>

                      <TableCell
                        sx={{
                          paddingRight: 0,
                          display: "flex",
                        }}
                      >
                        {data.action}
                      </TableCell>
                    </TableRow>

                    {loading && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "fixed",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          zIndex: 9999,
                          color: "white",
                        }}
                      >
                        <CircularProgress color="inherit" />
                      </Box>
                    )}
                  </React.Fragment>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <WebhookModal
        openWebhook={openWebhook}
        setOpenWebhook={setOpenWebhook}
        newWebhook={newWebhook}
        setNewWebhook={setNewWebhook}
        selectedWebhook={selectedWebhook}
        submit={submit}
        webhooks={webhooks}
        handleEdit={handleEdit}
        handleCancel={handleCancel}
        confirmDelete={confirmDelete}
        openConfirmation={openConfirmation}
        setOpenConfirmation={setOpenConfirmation}
        providerData={data}
        selectedWebhookData={selectedWebhookData}
        onRegisterWebhooks={handleRegisterWebhooks}
        registeringWebhooks={loading}
      ></WebhookModal>
      <DeleteConfirmationModal
        icon={
          <ChangeCircleIcon
            style={{
              width: 30,
              height: 30,
              marginTop: 15,
              color: "var(--error-red)",
            }}
          />
        }
        deleteButtonTitle="Change"
        title={`Are you sure you want to change publish to OMS for ${selectedOmsData?.provider?.name}?`}
        open={openOmsChangeConfirmation}
        handleClose={() => setOpenOmsChangeConfirmation(false)}
        handleDelete={(e) => {
          onChangePublishToOms(e);
        }}
      />
    </>
  );
};

export default OMSList;
